/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userBusinessCoupons.internal

import features.userBusinessCoupons.models.UserBusinessCouponsModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.userBusinessCoupons.internal.UserBusinessCouponsUseCase.Params

internal class UserBusinessCouponsUseCase : AsyncUseCase<UserBusinessCouponsModel, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,
        val businessId: String
    )

    private val userBusinessCouponsService: UserBusinessCouponsService = UserBusinessCouponsServiceImpl()

    override suspend fun run(params: Params): Result<UserBusinessCouponsModel> {
        return userBusinessCouponsService.getUserBusinessCoupons(
            overrideHeaders = params.overrideHeaders,
            businessId = params.businessId
        )
    }
}
